function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 14H29V16L11 16.01V14ZM29 19.01L11 19V21H29V19.01ZM11 24H23V26H11V24Z",
  fill: "#979797"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/full-desc.96a02f3d.svg";
export { SvgComponent as ReactComponent };